import { SYNCHRONISATIONLOGS } from 'constants/api';
import axios from 'utils/axios';

export const getSynchronisationlogs = async (data) => {
    const result = await axios.get(SYNCHRONISATIONLOGS.v2.fetchLogs, {
        params: data
    });
    return result.data;
};
